import React from 'react';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import type { BaseCardProps } from '../types';

const CardLabels: React.FC<Pick<BaseCardProps, 'labels'>> = (props) => {
  const { labels } = props;

  if (!labels) {
    return null;
  }

  return (
    <div className="Card__labels__wrapper">
      <div className="Card__labels">
        {labels.map((label) => (
          <span>
            {label.icon && (
              <Icon name={label.icon} flair="outlined" />
            )}
            {label.value}
          </span>
        ))}
      </div>
    </div>
  );
};

export default CardLabels;
